<template>
  <v-app-bar app flat absolute color="transparent">
    <div class="w-full">
      <div class="d-flex align-center mx-6">
        <v-app-bar-nav-icon
          v-if="sideBarShow"
          class="me-4"
          @click="$emit('appBarNavClick')"
        ></v-app-bar-nav-icon>

        <app-logo v-else class="me-4"></app-logo>

        <v-text-field
          v-if="showSearch"
          rounded
          dense
          outlined
          prepend-inner-icon="mdi-magnify"
          class="app-bar-search flex-grow-0"
          hide-details
          v-model="keyword"
          v-on:keyup.enter="search"
        ></v-text-field>

        <v-spacer></v-spacer>

        <div class="d-flex">
          <v-btn text v-if="showHomeMenu" :to="homePage">
            {{ home }}
          </v-btn>

          <horizontal-menu
            v-if="menus.length > 0"
            :menus="menus"
          ></horizontal-menu>

          <dev-menu v-if="showMenu && isInRole('admin')"></dev-menu>
        </div>

        <notification-button
          v-if="signedin && showNotification"
        ></notification-button>

        <user-menu v-if="showProfile"></user-menu>
      </div>
    </div>
  </v-app-bar>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useUserStore } from "../../../store/user";
import { useAppStore } from "../../../store/app";
import { useLocalStore } from "../../../store/local";

import AppLogo from "../AppLogo.vue";
import UserMenu from "./UserMenu.vue";
import HorizontalMenu from "./HorizontalMenu.vue";
import DevMenu from "./DevMenu.vue";

export default {
  name: "AppBar",

  components: { AppLogo, UserMenu, HorizontalMenu, DevMenu },

  props: ["isDrawerOpen"],

  data() {
    return {
      menus: [],
      keyword: null,
    };
  },

  computed: {
    ...mapState(useUserStore, ["signedin", "homePage", "showSearch"]),
    ...mapState(useAppStore, {
      sideBarShow: (store) => store.config.sideBarShow,
      showHomeMenu: (store) =>
        !store.config.sideBarShow && store.config.showHome,
      showMenu: (store) => !store.config.sideBarShow,
      showNotification: (store) => store.config.showNotification,
      searchPage: (store) => store.config.searchPage,
      showProfile: (store) => store.config.showProfile,
      projectMenus: (store) => store.projectMenus,
    }),
    ...mapState(useLocalStore, ["home"]),
  },

  async mounted() {
    let menus = this.projectMenus;

    if (menus) {
      for (let i = 0; i < menus.length; i++) {
        const e = menus[i];

        if (e.area == "main") {
          if (e.role) {
            if (this.isInRole(e.role)) this.menus.push(e);
            continue;
          }

          this.menus.push(e);
        }
      }
    }

    menus = await this.getMainMenus();

    menus.sort((a, b) => a.visibleIndex - b.visibleIndex);

    menus.forEach((x) => {
      x.children.sort((a, b) => a.visibleIndex - b.visibleIndex);
    });

    if (menus) {
      for (let i = 0; i < menus.length; i++) {
        const e = menus[i];

        if (e.role) {
          if (this.isInRole(e.role)) this.menus.push(e);
          continue;
        }

        this.menus.push(e);
      }
    }
  },

  methods: {
    search() {
      if (this.keyword) {
        if (this.searchPage) {
          this.$router.replace(
            "/pages/" + this.searchPage + "/" + this.keyword
          );
        }
      }
    },

    ...mapActions(useUserStore, ["isInRole", "getMainMenus"]),
  },
};
</script>
